<template>
    <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据导入/导出</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchData" class="user-search">
     
         <el-form-item label="下单日期">
          <el-date-picker
          v-model="searchData.daterange"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
    </el-date-picker>
    <el-form-item label="订单状态">
        <el-select v-model="searchData.status" placeholder="请选择订单状态">
          <el-option label="全部"  value="all" ></el-option>
          <el-option :label="items.name" :value="items.code"  :key="items.id" v-for="items  in statusList "></el-option>
        </el-select>
    </el-form-item>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="exportExcle()">导出报表</el-button>
      
      </el-form-item>
    </el-form>

    <div class="upload">
       <el-upload
            class="upload-demo"
            action="https://hmxzngl.km130.com/DataCenter/import_excel_data"
            :on-success="handleXlsxSuccess"
            :before-upload="beforeXlsxUpload"
            :headers="headerObj">
            <el-button size="small" type="primary">导入报表</el-button>
            <div slot="tip" class="el-upload__tip">只能上传Xlsx文件，且不超过2M</div>
        </el-upload>
    </div>

    


    <div class="infinite-list-wrapper" v-if="repeat" style="overflow:auto">
      <p>重复数据</p>
    <ul
      class="list"
      v-infinite-scroll="load"
      infinite-scroll-disabled="disabled">
      <li v-for="i in repeatData" :key="i" class="list-item">{{ i }}</li>
    </ul>
    <p >没有更多了</p>
  </div>
    </div>
</template>

<script>
import { search,export_data,getStatus} from '../../api/order'
import ExportJsonExcel from "js-export-excel"
export default {

    data(){
        return {
            repeat:false,
            repeatData:[],
            statusList:[],
            searchData:{
                daterange:'',
                status:'all',
                action:'export'
            },
            dataList:[],
            headerObj:{
              Authorization:localStorage.getItem('Authorization')
            },
        }
    },
    created(){
       getStatus().then(res=>{
              this.statusList=res.data
            })

    },
    methods:{
           beforeXlsxUpload(file) {
           // console.log(file.type);
                const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isXlsx) {
                this.$message.error('上传只能是 Xlsx 格式!');
                }
                if (!isLt2M) {
                this.$message.error('上传文件不能超过 2MB!');
                }
                return isXlsx && isLt2M;
        },
         handleXlsxSuccess(res, file) {
            this.repeatData=[];
            this.repeat=false;
            if(res.status==2){
               this.$message.success(res.message);
            }else if(res.status==3){
               this.$message.error(res.message);
               let $result_order_no_ids=res.result;
               this.repeatData=$result_order_no_ids.split(',');
               this.repeat=true;
            }else{
              this.$message.error(res.message);
            }
           
                
          //  this.imageUrl = URL.createObjectURL(file.raw);
        },

     exportExcle(){
       export_data(this.searchData).then(res=>{ 
          this.dataList=res.data.data
          const listData=this.dataList;
          let option={};
          let datatable=[];
          for(let i in listData){

            let obj={
              宽带类型:listData[i].type,
              宽带兆数:listData[i].mbps,
              客户名称:listData[i].u_name,
              手机号码:listData[i].phone,
              订单号:listData[i].order_no,
              集团ID:listData[i].group_id,
              快递单号:listData[i].express_order_number,
              宽带账号:listData[i].account,
              安装地址:listData[i].place,
            //  归属地:listData[i].belong,
              供应商:listData[i].provide,
              金额:listData[i].money,
              业务员:listData[i].salesmanName,
              下单时间:listData[i].order_time,
             // 到期时间:listData[i].expires_times,
              // 录单员:listData[i].id,
              状态:listData[i].status,
              备注:listData[i].desc,

            }
            datatable.push(obj);
          }
          
          option.filename="宽带报表";
          option.datas=[
            {
              sheetData:datatable,
              sheetName:'宽带报表',
              sheetData:datatable,
              sheetHeader:['宽带类型','宽带兆数','客户名称','手机号码','订单号','集团ID','快递单号','宽带账号','安装地址','供应商','金额','业务员','下单时间','状态','备注',],
              sheetFilter:['宽带类型','宽带兆数','客户名称','手机号码','订单号','集团ID','快递单号','宽带账号','安装地址','供应商','金额','业务员','下单时间','状态','备注',],
              columnWidths: ['8','6','6','6','6','6','6','6','20','6','6','6','6','6','6','6'], // 列宽
            }
          ]
          let toExcel= new ExportJsonExcel(option);
            toExcel.saveExcel();
       });
      
    }
        

    },
   
     
    
   

  }
</script>



<style scoped>
ul,li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.user-search {
  margin-top: 20px;
}
.infinite-list-wrapper{
  height: 300px;
  
}
.infinite-list-wrapper p{
  text-align: center;

}
.infinite-list-wrapper ul li{
      margin-top: 10px;
     display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background: #fff6f6;
    color: #ff8484;
} 
.upload{
  display: flex;
  align-items: center;
  min-height:500px ;
  justify-content: center;
}
.upload .upload-demo{
  height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/views/datacenter/export.vue